export default __webpack_public_path__ + "static/media/image-cushion-b-w@3x.dbe2d9b8.webp";